import Color from '../Color.mjs'
import superMeta from '../_MODULE/metaModuleNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREEN_YELLOW,
    codeProp: 'vmUserCode',
    mapIdProp: 'fcMapId',
    mapStsCodeProp: 'fcMapStsCode',
    mapTypeCode: 'FC_MAP',
    name: '程序域',
    ownerIdProp: 'ssId',
    ownerTextProp: 'ssName',
    ownerType: 'SS',
    textProp: 'vmName',
    type: 'VM',
}
